import {SFConstants} from "../../../constants/SFConstants";
import {ErrorCodes} from "../../../constants/shared/ErrorCodes";
import {Poker2Command} from "../Poker2Command";
import {Poker2PreloadEvent} from "../../../event/Poker2PreloadEvent";
import {BasicModel} from "@goodgamestudios/core";
import {Poker2Model} from "../../../model/Poker2Model";
import {Poker2AvatarCreationDialogPreload} from "../../../view/dialogs/registration/Poker2AvatarCreationDialogPreload";
import {Poker2SharedObject} from "../../../model/components/Poker2SharedObject";

/**
 * Bei Preload, nur Antwort auf SocialLogin!
 */
export class LGNPreCommand extends Poker2Command {

    protected get cmdId(): string {
        return "lgn";
    }

    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case 0:
                Poker2Model.userData.guestName = "";
                Poker2Model.userData.firstLogin = false;
                BasicModel.smartfoxClient.sendMessage("lgr", []);
                Poker2Model.localData.saveCookieExists();
                Poker2Model.sessionData.loggedIn = true;
                return true;
            case 21:
            case 20:
            case 27:
                var localData: Poker2SharedObject = new Poker2SharedObject();
                localData.saveLoginData("", "", false);
                this.controller.dispatchEvent(new Poker2PreloadEvent("socialLoginFaild", "", [error]));
                break;
            case 26:
                this.layoutManager.showDialog(Poker2AvatarCreationDialogPreload.NAME);
                break;
            case 17:
                Poker2Model.userData.guestName = "";
                Poker2Model.userData.firstLogin = true;
                BasicModel.smartfoxClient.sendMessage("lgr", []);
                Poker2Model.localData.saveCookieExists();
                Poker2Model.sessionData.loggedIn = true;
                break;
        }

        return false;
    }
}